/* @flow */
import apiRequest from 'lib/apiRequest';
import Collection from 'lib/Collection';
import Organization from 'entities/Organization';

class Organizations extends Collection {
  initialize() {
    this.model = Organization;
  }

  static suggest() {
    return apiRequest('/organizations/suggested', 'GET').then(
      response => Organizations.fromJSON(response)
    );
  }

  static search(queryType, query, page, perPage) {
    const options = {
      type: queryType.toLowerCase(),
      query,
      page: (page || 1),
      per_page: (perPage || 20),
    };

    return apiRequest('/organizations/find', 'GET', options).then(
      response => Organizations.fromJSON(response)
    );
  }
}

export default Organizations;



// WEBPACK FOOTER //
// ./src/collections/Organizations.js